<template>
  <div class="layout-modal">
    <div class="inline-block" ref="inline">
      <input
        type="checkbox"
        v-model="formData.inline"
        name="inline"
        id="layout-checkbox-1"
        class="checkbox-input"
      />
      <label for="layout-checkbox-1">
        Inline
        <tooltip :text="TOOLTIP_TEXT.INLINE"></tooltip>
      </label>
    </div>
    <div class="body" v-if="!simpleView">
      <div class="input-block grid-col-1-2 grid-row-1-2">
        <label>
          Sequence
          <span class="required">*</span>
          <tooltip :text="TOOLTIP_TEXT.SEQUENCE"></tooltip>
        </label>
        <input
          type="number"
          :value="this.formData.seq"
          name="seq"
          class="input-short"
          disabled
          required
        />
      </div>
      <div class="input-block grid-col-2-3 grid-row-1-2">
        <label>
          Vertical Align
          <tooltip :text="TOOLTIP_TEXT.VERTICAL_ALIGN"></tooltip>
        </label>
        <select name="verticalAlign" @change="setVerticalAlign($event)">
          <option value="start" :selected="getSelected('start')">Start</option>
          <option value="end" :selected="getSelected('end')">End</option>
          <option value="center" :selected="getSelected('center')">Center</option>
          <option value="baseline" :selected="getSelected('baseline')">Baseline</option>
        </select>
      </div>
      <div class="input-block grid-col-3-4 grid-row-1-2">
        <label>
          Margin Bottom
          <tooltip :text="TOOLTIP_TEXT.MARGIN_BOTTOM"></tooltip>
        </label>
        <input
          type="number"
          v-model="formData.marginBottom"
          name="marginBottom"
          class="input-short"
        />
      </div>
      <div class="input-block grid-col-4-5 grid-row-1-2">
        <label>
          Column Size
          <tooltip :text="TOOLTIP_TEXT.COLUMN_SIZE"></tooltip>
        </label>
        <input
          type="number"
          v-model="formData.colSize"
          name="colSize"
          class="input-short"
        />
      </div>
      <div class="class-block grid-col-5-7 grid-row-1-3">
        <label>
          Class Name
          <tooltip :text="TOOLTIP_TEXT.CLASS_NAME"></tooltip>
        </label>
        <textarea
          type="text"
          :value="this.getClassName"
          @change="setClassName($event)"
          name="className"
          class="class-input"
        />
      </div>
      
      <div class="checkbox-block grid-col-1-2 grid-row-2-3">
        <input
          type="checkbox"
          v-model="formData.border"
          name="border"
          id="layout-checkbox-2"
          class="checkbox-input"
        />
        <label for="layout-checkbox-2">
          Border
          <tooltip :text="TOOLTIP_TEXT.BORDER"></tooltip>
        </label>
      </div>
      <div class="checkbox-block grid-col-2-3 grid-row-2-3">
        <input
          type="checkbox"
          v-model="formData.padded"
          name="padded"
          id="layout-checkbox-3"
          class="checkbox-input"
        />
        <label for="layout-checkbox-3">
          Padded
          <tooltip :text="TOOLTIP_TEXT.PADDED"></tooltip>
        </label>
      </div>
    </div>
  </div>
</template>

<script>
import Tooltip from "./Tooltip.vue";
import { TOOLTIP_TEXT } from "../mixins/constant-mixin";
import { Bus } from "../main";

export default {
  name: "LayoutModal",
  props: {
    layout: {
      type: Object,
      required: true,
    },
    state: {
      type: Object,
    },
    simpleView: {
      type: Boolean,
    },
  },
  data() {
    return {
      formData: structuredClone(this.layout),
      TOOLTIP_TEXT: TOOLTIP_TEXT,
    };
  },
  watch: {
    layout: function () {
      this.formData = structuredClone(this.layout);
    },
    state: function () {
      if (this.state.closing) {
        if (!this.state.saving) {
          this.formData = structuredClone(this.layout);
        }
        this.$emit("layoutSaved", this.formData);
      }
    },
  },
  components: {
    "tooltip": Tooltip,
  },
  created() {
    Bus.$on("insertIntoComponentModal", (parent, gridrow) => {
      const inline = this.$refs.inline;
      if (inline) {
        inline.style.gridRow = gridrow;
        parent.insertAdjacentElement("beforeend", inline);
      }
    });
  },
  beforeDestroy() {
    Bus.$off("insertIntoComponentModal");
  },
  methods: {
    getSelected: function (value) {
      let verticalAlign = "start";
      if (this.formData.verticalAlign) {
        verticalAlign = this.formData.verticalAlign;
      }
      return verticalAlign.toLowerCase() === value;
    },

    setVerticalAlign: function (event) {
      this.formData.verticalAlign = event.target.value;
    },
    setClassName: function (event) {
      const classArr = event.target.value
        .replaceAll("\n", " ")
        .split(" ")
        .filter((e) => e.trim() != "");
      this.formData.className = classArr.join(" ");
    },
    checkboxOnChange: function (event) {
      this.formData[event.target.name] = event.target.checked;
    },
  },
  computed: {
    getClassName: function () {
      if (!this.formData.className) {
        return "";
      }
      const classArr = this.formData.className
        .replaceAll("\n", " ")
        .split(" ")
        .filter((e) => e.trim() != "");
      const classes = classArr.join("\n");
      return classes;
    },
  },
};
</script>

<style scoped>
.layout-modal {
  width: 100%;
}

.body {
  padding: 1rem 0;
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  grid-template-rows: repeat(2, 1fr);
  justify-items: center;
}

.input-block {
  display: flex;
  flex-direction: column;
  width: fit-content;
}

.input-block input,
.input-block select {
  padding: 8px 4px;
  box-sizing: border-box;
}

.input-short {
  text-align: center;
  width: 6rem;
}

/* Hide arrow in number input */
/* Chrome and safari */
input[type="number"]::-webkit-outer-spin-button,
input[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}

.class-block {
  grid-column: 5 / 7;
  grid-row: 1 / 3;
  display: flex;
  flex-direction: column;
  justify-self: start;
  padding: 0 1rem;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
}

.class-input {
  width: 100%;
  height: 100%;
  resize: none;
  padding: 4px 8px;
  margin-bottom: 1rem;
  box-sizing: border-box;
}

.inline-block {
  align-self: center;
  margin-left: 0.5rem;
  display: flex;
  align-items: center;
  padding: 0 2rem;
  margin-left: 0.5rem;
}

.checkbox-block {
  align-self: center;
  margin-left: -2rem;
  display: flex;
  align-items: center;
}

.checkbox-input {
  margin-right: 8px;
  width: 16px;
  height: 16px;
}

input,
select,
textarea {
  margin-top: 4px;
}

.grid-col-1-2 {
  grid-column: 1 / 2;
}

.grid-col-2-3 {
  grid-column: 2 / 3;
}

.grid-col-3-4 {
  grid-column: 3 / 4;
}

.grid-col-4-5 {
  grid-column: 4 / 5;
}

.grid-col-5-7 {
  grid-column: 5 / 7;
}

.grid-row-1-2 {
  grid-row: 1 / 2;
}

.grid-row-2-3 {
  grid-row: 2 / 3;
}

.grid-row-1-3 {
  grid-row: 1 / 3;
}

.required {
  color: #f00;
}
</style>